<template>
  <a href="#" class="smart-press-button" id="smart-panel-logo" @mousedown="startDrag">SmartPress</a>
</template>

<script>
export default {
  name: 'DragHandle',
  methods: {
    startDrag(event) {
      // Only start drag on left mouse button
      if (event.button !== 0) return;
      
      // Emit event to parent component
      this.$emit('start-drag', event);
      
      // Prevent text selection during drag
      event.preventDefault();
    }
  }
}
</script>

<style scoped>
/* Add cursor style to indicate draggable element */
#smart-panel-logo {
  cursor: move;
}
</style> 